<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs12>
                <h1>Финансовые показатели</h1>
                <div
                    class="help_tip mb-3"
                >Основные финансовые показатели компании за прошедший квартал и за два предыдущих года. Отрицательные значения вводятся с минусом. Актив и пассив должны быть равны во всех графах.</div>
            </v-flex>
            <v-flex xs12 py-0>
                <v-divider />
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12>
                <v-divider />
            </v-flex>
        </v-layout>

        <v-layout row wrap v-if="isPublicUrl">
            <v-flex xs6 finance__public-url>
                <h4>
                    Публичная ссылка на загрузку документов
                    <tips tipId="publicLink" compact class="ml-2" />
                </h4>
                <a :href="publicUrl" v-if="publicUrl">{{ publicUrl }}</a>
                <em class="error--text" v-else>отсутствует</em>
            </v-flex>

            <v-flex pt-4 shrink>
                <v-btn
                    @click="getPublicLink"
                    color="primary"
                    outlined
                >{{ publicUrl ? "Обновить" : "Получить" }} public ссылку</v-btn>
            </v-flex>
            <v-flex shrink pt-4 finance__public-url-copy v-if="publicUrl">
                <copy-string :copy-data="publicUrl" />
            </v-flex>
            <v-flex shrink pt-4 v-if="publicUrl">
                <v-btn color="error" @click="resetPublicLink" icon text outlined>
                    <v-icon color="error" size="20">clear</v-icon>
                </v-btn>
            </v-flex>
            <v-flex xs12>
                <v-divider />
            </v-flex>
        </v-layout>

        <loading v-else />

        <v-layout row wrap block>
            <v-flex xs12>
                <loading v-if="!isLoaded" />
                <finance v-else :finance-data="finances" :editMode="true" :packageMode="false" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import finance from "@/components/clients/finance";
import CopyString from "@/components/lib/copy";
import tips from "@/components/lib/tips";

export default {
    name: "ClientFinance",
    data: () => ({
        finances: {},
        isLoaded: false,
        publicUrl: null,
        isPublicUrl: false,
        publicHash: null
    }),
    components: {
        finance,
        CopyString,
        tips
    },
    methods: {
        async getFinances() {
            this.isLoaded = false;
            await apiCallTrue({
                url: "v1/financials"
            })
                .then(response => {
                    this.finances = response.data.data;
                    if (response.data.data.publicHash) {
                        this.publicHash = response.data.data.publicHash;
                        this.publicUrl = this.setPublicLink(
                            response.data.data.publicHash
                        );
                    }
                    this.isLoaded = true;
                    this.isPublicUrl = true;
                })
                .catch(error => {
                    console.log(error, "finances error");
                    this.isLoaded = true;
                });
        },
        getPublicLink() {
            // const TYPE_LIVE_FORM_DOCUMENTS = 3;
            // const TYPE_LIVE_FORM_FINANCIALS = 4;
            apiCallTrue({
                method: "POST",
                url: "v1/users/public-hash-type-link",
                data: { type: 4 }
            })
                .then(response => {
                    this.publicHash = response.data.data;
                    this.publicUrl = this.setPublicLink(this.publicHash);
                })
                .catch(error => {
                    console.log(error, "licence error");
                });
        },
        setPublicLink(link) {
            return `${window.location.origin}/public-financials/${link}`;
        },
        resetPublicLink() {
            apiCallTrue({
                method: "POST",
                url: "v1/users/delete-public-hash-type-link",
                data: { hash: this.publicHash }
            })
                .then(response => {
                    if (response.data.result) {
                        this.publicUrl = null;
                    }
                })
                .catch(error => {
                    console.log(error, "licence error");
                });
        }
    },
    mounted() {
        this.getFinances();
    }
};
</script>

<style lang="scss">
.finance {
    &__public-url {
        a {
            word-break: break-all;
            font-size: 12px;
            text-decoration: none;
            margin-right: 50px;
            display: inline-block;
            vertical-align: top;
        }
        &-copy {
            position: relative;
        }
    }
}
</style>
